var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('user-feed',{attrs:{"selectedTab":_vm.tab,"searchText":_vm.searchText}})
}
var staticRenderFns = []

export { render, staticRenderFns }